// extracted by mini-css-extract-plugin
export default {"toolTipBody":"mA1rUHraReRG5UKoU7vk","TooltipTitle":"prG6FoNCXD62LVKlR8ME","TooltipContent":"vQjtcyMLaMT3D36W1OjH","TooltipFooter":"rOHmQ6LWLtzYoQIWe6Nx"};